import React, { useState, useEffect } from "react";
import  "./imgGeneratorHero.scss";
import Link from "next/link";
import Image from "next/image";

import { useRouter } from "next/navigation";
import { IoSearchOutline } from "react-icons/io5";

import commingSoon from "@/../public/home/hero/commingSoon.svg";
import imgGenerator01 from "@/../public/home/hero/imgGenerator01.jpg";
import imgGenerator02 from "@/../public/home/hero/imgGenerator02.jpg";
import imgGenerator03 from "@/../public/home/hero/imgGenerator03.jpg";
import imgGenerator04 from "@/../public/home/hero/imgGenerator04.jpg";

const list = [imgGenerator01, imgGenerator02, imgGenerator03, imgGenerator04];

const textList = [
  "Couple in Paris romantic sunset",
  "Indian women in Dubai city",
  "Indian boy with Butterfly on him",
  "young Indian girl in temple smiling",
];
export default function ImgGeneratorHero({
  setDisplayCard,
  setShowCommingSoonModal,
  path,
}) {
  const router = useRouter();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [typingText, setTypingText] = useState("");
  const [typingCompleted, setTypingCompleted] = useState(false);
  const [showBlur, setShowBlur] = useState(true);

  useEffect(() => {
    const currentIndex = typingText.length;
    const currentTarget = textList[currentImageIndex];
    const targetLength = currentTarget.length;

    const timePerCharacter = 3000 / targetLength;

    if (!typingCompleted && currentIndex < targetLength) {
      const timeout = setTimeout(() => {
        setTypingText(currentTarget.substring(0, currentIndex + 1));
      }, timePerCharacter);

      return () => clearTimeout(timeout);
    }
  }, [typingText, typingCompleted, currentImageIndex]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % list.length);
      setTypingText("");
      setTypingCompleted(false);
      setShowBlur(true);

      setTimeout(() => {
        setShowBlur(false);
      }, 3500);
    }, 6000);
    return () => clearInterval(intervalId);
  }, []);

  const currentImage = list[currentImageIndex];

  return (
    <div
      onClick={() => setDisplayCard("generator")}
      className="faceSwap"
    >
      <div
        onClick={() => router.push(`${path}`)}
        className="imgContainer"
      >
        <Image
          src={currentImage}
          alt="ai-face-swap"
          className={`img ${showBlur ? "blur" : ""}`}
        />
      </div>
      <div
        onClick={() => router.push(`${path}`)}
        className="faceSwapContent"
      >
        <div className="productTop">
          <div className="titleContainer">
            <p className="title">AI Image Generator (Now with Flux)</p>
            {/*  <div className={styles.free}>
              <Image src={commingSoon} alt="face-swap" />
              <p className={styles.freeTxt}>Face Personalization Unlocked!</p>
            </div> */}
          </div>
          {/* <p className={styles.description}>
            Turn your ideas into reality and generate stunning visual content.
          </p> */}
        </div>
        <div className="bottom">
          <div className="search">
            <p className="prompt">
              {typingCompleted ? (
                textList[currentImageIndex]
              ) : (
                <>{typingText}</>
              )}
            </p>
            <IoSearchOutline className="svg" />
          </div>
          <Link href={`${path}`} className="link">
            <button className="btn1 btn">Try it out</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
